import React from "react";
import DataTable from "react-data-table-component";

const CustomDataTable = ({
  columns,
  data,
  totalRows,
  loading,
  handlePageChange,
  handleRowsPerPageChange,
  currentPage,
  perPage,
}) => {
  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      progressPending={loading}
      paginationDefaultPage={currentPage} // Keeps page state correct
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handleRowsPerPageChange}
      fixedHeader
      fixedHeaderScrollHeight="440px"
    />
  );
};

export default CustomDataTable;
